document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/g, "") + "js"

if (window.location.hash) { setTimeout(function () { window.scrollTo(0, 0); }, 2); }

(function ($) {
    var $body = $('body');
    var $header = $('header.gheader');
    var $nav = $header.find('.menu-container');
    
    function adjustPositions() {
        var $header = $('header.gheader');
        var headerHeight = $header.outerHeight();
        var adminHeight = $('#wpadminbar').outerHeight();
        var totalHeight = headerHeight;
    }

    $(window).resize(function () {
        adjustPositions();
    });
})(jQuery);


jQuery(document).ready(function ($) {


     var urlParams = (function (strParam) {
        var objParams = {};
        function init(){
            objParams = {};
            // get url parameters
            var arrURLParams = window.location.search.replace('?', '').split('&');
            // obj placeholder for params
            // convert parameters into an object
            arrURLParams.map(function (val) {
                var arrPair = val.split('=');
                objParams[arrPair[0]] = decodeURIComponent(arrPair[1]);
            });
        }
        init();
        return {
            get: function (strParam) { return objParams[strParam]; },
            pull: init
        }
    }());


  AOS.init({
        delay: 250,
        once: true,
        disable: 'mobile'
    });

    if ($(window).width() > 960) {
      $(window).on('scroll', function () {
        $('.stats-block .stats-row__item.aos-animate .count').not('.animate-started').each(function () {

            var $this = $(this);
            var number = $this.attr('data-count');

            $this.addClass('animate-started')
            $({
                countNum: $this.text()
            }).animate({
                countNum: number
            }, {
                duration: 1000,
                easing: 'swing',
                step: function () {
                    $this.text(addCommas(Math.floor(this.countNum)));
                },
                complete: function () {
                    this.countNum = addCommas(this.countNum);
                    $this.text(this.countNum);
                }
            });

        });
    });   

  } else {
    $('.stats-block .stats-row__item .count').each(function () {
         var number = $(this).attr('data-count');
        $(this).text(number);
    });
  }


          // ADD COMMAS TO COUNTERS
    function addCommas(nStr) {
        nStr += '';
        x = nStr.split('.');
        x1 = x[0];
        x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    }

        var SmoothScroll = (function () {
        var $anchorLinks = $('a[href^="#"]').not('a[href="#"]');

        $('a[href="#"]').click(
            function (e) { e.preventDefault(); return; }
        );

        function goTo(target) {
            if (target === "" || !$(target).length) { return; }
            var scrollPos = typeof target === 'number' ? target : $(target).offset().top;

            if (window.innerWidth >= 720) {
                scrollPos -= $('header').outerHeight();
            } else {
                scrollPos -= $('header').outerHeight() * 2;
            }

            $('html, body').stop().animate({
                'scrollTop': scrollPos - 32
            }, 1200, 'swing', function () {
                if (typeof target === 'string') {

                    if (window.location.hash) {
                        // window.location.hash = target;
                    }
                }
            });
        }

        if (window.location.hash) {
            setTimeout(function () {
                goTo(window.location.hash);
            }, 500);
        }

        if ($anchorLinks.length) {
            $anchorLinks.on('click', function (e) {

                if ($(this).attr('href') == '#all-countries-popup') {

                } else {
                if (!$("#" + this.hash.replace('#', '')).length) { return; }
                e.preventDefault();
                goTo(this.hash);
            }
            });
        }

        return { to: goTo }
    }());




    /*-----------------------------------------------------------------------------GLOBAL ON LOAD----*/

    var lazyLoadInstance = new LazyLoad();

    //Load images, and images after doc ready
    var lazyLoadItems = (function () {

        function init() {
            var $lazyItems = $('img[data-src]:not(.lazy), iframe[data-src], script[data-src], [data-background]');
            //console.log($lazyItems);
            if (!$lazyItems.length) { return; }
            $lazyItems.each(function () {
                var $this = $(this),
                    delay = 0,
                    dataSrc;
                if (dataSrc = $this.data('background')) {
                    if ($this.data('background-delay')) {
                        delay = $this.data('background-delay');
                    }
                    setTimeout(function () {
                        $this.css('background-image', 'url(' + dataSrc + ')');
                        $this.attr('data-background', null);
                    }, delay);
                } else if (dataSrc = $this.data('src')) {
                    if ($this.data('src-delay')) {
                        delay = $this.data('src-delay');
                    }
                    setTimeout(function () {
                        $this.attr('src', dataSrc);
                        $this.attr('data-src', null);
                        $this.attr('srcset', dataSrc);
                        $this.attr('data-srcset', null);
                    }, delay);
                }
            });
        }

        init();
        return { init: init }

    }());

    //Global function to toggle simple accordions
    var Accordions = (function () {
        var $accordions = $('.accordion');
        if (!$accordions.length) { return; }

        /*    $accordions.each(function () {
                $this = $(this).find('.accordion__trigger');
                if ($this.hasClass('active')) {
                    $this.next().slideToggle(250);
                }
            });*/
        $(document).on('click', '.accordion__trigger', function () {

            var $this = $(this);
            if ($this.hasClass('active')) {
                $(".accordion__trigger").removeClass('active');
                $(".accordion__trigger").next().slideUp(250);
                //console.log('has-active');
                $this.removeClass('active');
                $this.next().slideUp(250);
            } else {
                $(".accordion__trigger").removeClass('active');
                $(".accordion__trigger").next().slideUp(250);
                //console.log('add active');
                $this.addClass('active');
                $this.next().slideDown(250);
            }

        });

        $(".faqs-items .tabgroup").each(function(){
            $(this).find(".accordion__item").first().children(".accordion__trigger").addClass("active");  
            $(this).find(".accordion__item").first().children(".accordion__content").show();
        });
    }());



 var headerCountryDropdown = (function () {
       $(document).on('click', '.wpml-country-dd__trigger', function () {
         var $this = $(this);
       if ($this.hasClass('active')) {
            $this.removeClass('active');
            $this.parent().find(".wpml-country-dd__list").slideUp(250);
        } else {
            $this.addClass('active');
            $this.parent().find(".wpml-country-dd__list").slideDown(250);
        }
        
    });

  }());

  var footerSelectCountry = (function () {
    $(document).on('click', '.footer-country-select__trigger', function () {
         var $this = $(this);
       if ($this.hasClass('active')) {
            $this.removeClass('active');
            $this.parent().find(".footer-country-select__dd").slideUp(50);
        } else {
            $this.addClass('active');
            $this.parent().find(".footer-country-select__dd").slideDown(50);
        }
        
    });


    $(document).on('click', '.footer-country-select__dd .btn', function () {
         var $this = $(this);
         var $text = $(this).text();
         //console.log($text);
         var $link = $this.data('country-link');
         $this.parent().parent().find(".footer-country-select__trigger").removeClass('active');
         $this.parent().parent().find(".footer-country-select__dd").slideUp(50);
         $this.parent().parent().find(".footer-country-select__trigger span").html($text);
         $this.parent().parent().find(".btn-country-select").attr("href", $link);
         $this.parent().parent().find(".btn-country-select").removeClass("disabled");
        
    });

  }());


 var filterDropdown = (function () {
       $(document).on('click', '.dropdown-btn', function () {
         var $this = $(this);
       if ($this.hasClass('active')) {
            //console.log('has active');
            $this.removeClass('active');
            $this.parent().find(".dropdown-container").slideUp(250);
        } else {
            //console.log('no active');
            $this.addClass('active');
            $this.parent().find(".dropdown-container").slideDown(250);
        }
        
    });
    $('.category-list button').click(function() {
        $('.category-list button').removeClass('active');
        $(this).addClass("active");
    });
  }());

    var Forms = (function () {
        var InputMasks = (function () {
            var $masks = $('[data-mask]');
            if (!$masks.length) { return; }

            /**
             * Key Codes:
             * 8    - backspace
             * 13   - enter
             * 16   - shift
             * 18   - alt
             * 20   - caps
             * 27   - esc
             * 37   - left arrow
             * 38   - up arrow
             * 39   - right arrow
             * 40   - down arrow
             * 46   - delete
             **/
            var exclude_keys = [8, 13, 16, 18, 20, 27, 37, 38, 39, 40, 46];

            $('[data-mask]').keyup(function (e) {
                //console.log(e.keyCode);
                if (exclude_keys.indexOf(e.keyCode) > -1) { return; }

                switch (this.dataset.mask) {
                    case 'digits':
                        var x = this.value.replace(/\D/g, '');
                        this.value = x;
                        break;
                    case 'phone':
                        var x = this.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                        //console.log(x);
                        this.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                        break;
                    case 'ssn': {
                        var x = this.value.replace(/\D/g, '').match(/^(\d{0,3})(\d{0,2})(\d{0,4})/);
                        this.value = !x[2] ? x[1] : x[1] + '-' + x[2] + '-' + x[3];
                    }
                }
            });
        }());

        //Plugin used for form validation
        var parselyOptions = {
            classHandler: function (parsleyField) {
                var $element = parsleyField.$element;
                if ($element.parent().hasClass('select-menu')) {
                    return $element.parent();
                }
                return $element;
            },
            errorsContainer: function (parsleyField) {
                var $element = parsleyField.$element;
                var $fieldContainer = $element.closest('.form-field');
                if ($fieldContainer) {
                    return $fieldContainer;
                }
            }
        };

        //Global function to set form state classes
        var formStates = (function () {
            $formInputs = $('main form :input');
            if (!$formInputs.length) { return; }

            $formSelectMenus = $('.select-menu select, .ginput_container_select select');

            function isGFormInput($el) {
                return $el.hasClass('ginput_container') ? $el.parent() : $el;
            }

            function setFilled($input) {
                var $parent = isGFormInput($input.parent());

                $parent.addClass('filled');
            }

            function removeFilled($input) {
                var $parent = isGFormInput($input.parent());

                $parent.removeClass('filled');
            }

            function setFocused() {
                var $parent = isGFormInput($(this).parent());

                $parent.addClass('focused');
            }

            function removeFocused() {
                var $parent = isGFormInput($(this).parent());

                $parent.removeClass('focused');
            }

            function checkInput(e) {
                if (this.type == 'button' ||
                    this.type == 'range' ||
                    this.type == 'submit' ||
                    this.type == 'reset') { return; }

                var $this = $(this);
                var $parent = $this.parent();
                var is_selectMenu = $parent.hasClass('select-menu') || $parent.hasClass('ginput_container_select');

                var $input = is_selectMenu ? $parent : $this;

                switch (this.type) {
                    case 'select-one':
                    case 'select-multiple':
                        if (this.value !== '') {
                            setFilled($input);
                        } else {
                            removeFilled($input);
                        }
                        break;
                    default:
                        if (this.value) {
                            setFilled($input);
                        } else {
                            removeFilled($input);
                        }
                        break;
                }
            }

            $formInputs.each(checkInput);
            $formInputs.on('change', checkInput);
            $formInputs.on('focus', setFocused);
            $formInputs.on('blur', removeFocused);
            $formSelectMenus.on('focus', setFocused);
            $formSelectMenus.on('blur', removeFocused);

        }());
    }());

    //Global function top open / close lightboxes
    var PDMLightbox = (function () {

        var $body = $('body');
        //Lightbox reset - This lightbox is empty and present on all pages
        var $lightbox = $('.pdm-lightbox--reset');

        //it's content can be filled from various sources
        //after close, the content is wiped
        var $lightbox_content = $('.pdm-lightbox--reset .pdm-lightbox__content');

        $body.on('click', '[data-lightbox-iframe],[data-lightbox-content],[data-lightbox-target],.lightbox-trigger', function (e) {

            e.preventDefault();

            var classes = $(this).data('lightbox-classes');
            var iframe = $(this).data('lightbox-iframe');
            var blur = $(this).data('lightbox-blur');

            if (iframe) {

                var youtubeMatch = iframe.match(/watch\?v=([a-zA-Z0-9\-_]+)/);
                var vimeoPattern = /(?:http?s?:\/\/)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/g;



               if( youtubeMatch ){
                    iframe = '<div class="spacer"><iframe width="420" height="345" frameborder="0" allowfullscreen src="https://www.youtube.com/embed/' + youtubeMatch[1] +'" /><div>';
                    classes += ' youtube-vid'

                } 

                 else if (vimeoPattern.test(iframe)) {

                    classes += ' vimeo-vid'

                    replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="//player.vimeo.com/video/$3?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';

                    iframe = iframe.replace(vimeoPattern, replacement);

                } else {
                    iframe = '<video width="100%" height="100%" controls><source src="'+iframe+'" type="video/mp4"></video>'
                    classes += ' regular-vid'

                }

                $lightbox_content.html('<div class="iframe-wrap">' + iframe + '</div>');

            } else {
                if ($(this).data('lightbox-content')) {
                    var content = $(this).data('lightbox-content');
                } else if ($(this).data('lightbox-target')) {
                    var target = $(this).data('lightbox-target');
                    var content = $('#' + target).html();
                } else {
                    var content = $(this).closest('.lightbox-container').find('.lightbox-content').html();
                }
                $lightbox_content.html(content);
            }

            if (blur != false) {
                $body.addClass('blur');
            }

            $lightbox.addClass('active').addClass(classes);

        });

        function closeLightbox($lightbox) {
            $lightbox.removeClass('active');
            $('body').removeClass('noScroll');
            setTimeout(function () {
                $body.removeClass('blur');
            }, 250);
            //wait before removing classes till lightbox closses
            if ($lightbox.hasClass('pdm-lightbox--reset')) {
                setTimeout(function () {
                    $lightbox.find('.pdm-lightbox__content').empty();
                    $lightbox.attr('class', 'pdm-lightbox pdm-lightbox--reset');
                }, 750);
            }
        }

        $('.pdm-lightbox').on('click', function (e) {
            var $lightbox = $(this);
            if (e.target == this) {
                closeLightbox($lightbox);
            }
        });

        $('.pdm-lightbox__close').click(function (e) {
            e.stopPropagation();
            $lightbox = $(this).closest('.pdm-lightbox');
            closeLightbox($lightbox);
        });
        return {
            close: closeLightbox
        };
    }());

  

      var singlePost = (function () {

        if ($('body').is('.single-post, .single-case-studies, .page-template-default, .single-residents-blog, .single-user_insights'
        )) {

            //console.log('single post');

            $headings = $('.page-content h2');

            if ($headings.length) {

                $('.toc').show();

                $headings.each(function () {
                    var text = $(this).text().replace(':', '');
                    //                console.log(text);
                    var id = text.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-').toLowerCase();
                    $(this).attr('id', id);

                    $('.toc ul').append('<li><button class="reset" data-target="' + id + '">' + text + '</button>');
                });

                $('.toc').on('click', 'button', function () {
                    //                $('.toc li.active').removeClass('active');
                    //                $(this).parent().addClass('active');
                    var target = $(this).data('target');
                    $('html, body').animate({
                        scrollTop: $('h2#' + target).offset().top - 100
                    }, 1000);
                });

            }

            var $progressBar = $('.progress-bar .progress')
            var lastScrollTop = 0;

            function updateProgress() {
                var scrollableHeight = $('.page-content__row').outerHeight();
                var currentProgress = $('.page-content__row').position().top + $('.page-content__row').outerHeight();
                currentProgress = currentProgress;
                currentProgress = currentProgress - ($(window).scrollTop() + ($(window).height() / 2));
                currentProgress = 100 - ((currentProgress / scrollableHeight) * 100);
                $progressBar.css('width', currentProgress + '%');     
                if ($('.toc__container').length) {
                    var scrollTop = $(window).scrollTop();
                    $headings.each(function () {
                        var elementOffset = $(this).offset().top,
                            distance = (elementOffset - scrollTop);

                        if (scrollTop > lastScrollTop) {
                            if (distance > 0 && distance < 250) {
                                var tocItem = $(this).attr('id');
                                $('.toc li.active').removeClass('active');
                                $('.toc button[data-target="' + tocItem + '"]').parent().addClass('active');
                            }
                        } else {
                            if (distance < (250) && distance < (500)) {
                                var tocItem = $(this).closest('h2').attr('id');
                                $('.toc li.active').removeClass('active');
                                $('.toc button[data-target="' + tocItem + '"]').parent().addClass('active');
                            }
                        }
                    });

                    lastScrollTop = scrollTop;

                }                
            }
            $(window).scroll(updateProgress);
            $(window).resize(updateProgress);

        }

    }());  



     var twoColumnSticky = (function () {



    if ($(window).width() > 960) {
      $(window).on('scroll', function () {
        $('.two-column-sticky .icon-item.aos-animate').each(function () {
            var $this = $(this);
            $this.addClass('active');
 
        });
    });   

  } 

    }());      


    //******************************************************Everything under this is optional, feel free to delete

    var Header = (function () {
        var $body = $('body');
        var $header = $('header.gheader');
        var $nav = $header.find('.menu-container');
        var $adminBar = $('#wpadminbar');

        var header_height = $header.innerHeight();
        if (window.innerWidth < 1350) { $nav.css({ marginTop: header_height }); }

        $(window).trigger('resize');

        var BurgerMenu = (function () {
            var $burgerMenu = $header.find('.burger-container');
            var $text = $burgerMenu.find('.menu-burger__text');

            function activate() {
                $burgerMenu.addClass('active').attr('title', 'Close');
                $nav.addClass('active');
                $body.addClass('no-scroll');
                $body.addClass('bg-overlay');
            }

            function reset() {
                $burgerMenu.removeClass('active').attr('title', 'Menu');
                $nav.removeClass('active').find('.active').removeClass('active');
                $body.removeClass('no-scroll');
                $body.removeClass('bg-overlay');
            }

            $burgerMenu.click(function () {
                var $this = $(this);

                if ($this.hasClass('active')) { reset(); } else { activate(); }
            });

               return {
                close: reset,
                open: activate
            }
        }());

        window.addEventListener('resize', function () {

             BurgerMenu.close();

            var styles = { marginTop: window.innerWidth < 1350 ? header_height : 0 };

            $nav.css(styles);
        });

        var DropdownMenus = (function () {
            var $menus = $('.menu');
            var $dropmenus = $menus.find('.dropdown.menu-item');
            var $mobileArrow = $dropmenus.find('.mobile-arrow');

            function toggleDropdown(e) {
                e.preventDefault();

                var $this = $(this);
                var $menuItem = $this.closest('.dropdown');

                $dropmenus.not($menuItem).removeClass('active');

                if ($menuItem.hasClass('active')) {
                    $menuItem.removeClass('active');
                } else {
                    $menuItem.addClass('active');
                }
            }

            $mobileArrow.click(toggleDropdown);
        }());

    }());

    var footerMenus = (function () {
        $('.menu--foot').on('click', '.mobile-arrow', function () {
            $('.dropdown-menu').removeClass("active");
            if ($(this).hasClass('active')) {
                $(this).removeClass("active");
                $(this).closest('.dropdown').find('.dropdown-menu').removeClass("active");
            } else {
                $('footer').find('.mobile-arrow').removeClass("active");
                $(this).addClass("active");
                $(this).closest('.dropdown').find('.dropdown-menu').addClass("active");
            }
        });

    }());


/* var heroHoliday = (function () {

    $heroVideoSlider = $('.hero--video-bg');
    if (!$heroVideoSlider.length) { return };

    var items = $(".hero-video-slider__item");

    function showSecondItem() {
        items.eq(1).fadeIn(1000); // Show the second item
        items.eq(0).fadeOut(1000); // Hide the first item
    }

    // Initially, show the first item
    items.eq(0).fadeIn(1000);

    // Use setTimeout to show the second item after 7 seconds
    setTimeout(showSecondItem, 7000);
  }());*/

    var testimonialSlider = (function () {
        $sliders = $('.testimonial-slider');
        if (!$sliders.length) { return };
        $sliders.each(function () {
            var $slider = $(this);
            $slider.flickity({
                prevNextButtons: false,
                contain: false,
                pageDots: false,
                cellAlign: 'left',
                freeScroll: true,
                draggable: false,
            });

            // Flickity instance
            var flkty = $slider.data('flickity');
            // elements
            var $cellButtonGroup = $('.button-dots');
            var $cellButtons = $cellButtonGroup.find('.button-dots__dot');

            // update selected cellButtons
            $slider.on('select.flickity', function () {
                $cellButtons.filter('.is-selected')
                    .removeClass('is-selected');
                $cellButtons.eq(flkty.selectedIndex)
                    .addClass('is-selected');
            });

            // select cell on button click
            $cellButtonGroup.on('click', '.button-dots__dot', function () {
                var index = $(this).index();
                $slider.flickity('select', index);
            });
            // previous
            $slider.closest(".two-column__column").find('.flick-nav.prev').on('click', function () {
                $slider.flickity('previous');
            });
            // next
            $slider.closest(".two-column__column").find('.flick-nav.next').on('click', function () {
                $slider.flickity('next');
            });

        });
    }());

    var rowSlider = (function () {
        $sliders = $('.row-slider');
       
        if (!$sliders.length) { return };
        $sliders.each(function () {
            var $slider = $(this);
            var $slider_card = $(this).find('.slider-card');
            if($slider_card.length > 3) {
            $slider.flickity({
                prevNextButtons: false,
                contain: true,
                pageDots: false,
                freeScroll: false,
                draggable: false,
                wrapAround: true,
                cellAlign: 'left',
                autoPlay: 2000

            });

            // Flickity instance
            var flkty = $slider.data('flickity');

            // previous
            $slider.closest(".tabgroup").find('.flick-nav.prev').on('click', function () {
                $slider.flickity('previous');
            });
            // next
            $slider.closest(".tabgroup").find('.flick-nav.next').on('click', function () {
                $slider.flickity('next');
            });
        } else {
            $slider.closest(".tabgroup").find('.flick-nav-container').addClass("flick-nav-container--hide");
        }

        });
        
    }());

     var videoSlider = (function () {
        $sliders = $('.videos-list.slider');
       
        if (!$sliders.length) { return };

            $sliders.each(function () {
                var $slider = $(this);
                var count = $slider.find('.video-card-container').length;
                if(count > 3) {
                $(this).closest('section').find('.flick-nav-container').addClass('active');
                $slider.flickity({
                    prevNextButtons: false,
                    contain: true,
                    pageDots: true,
                    freeScroll: false,
                    draggable: false,
                    wrapAround: true,
                    cellAlign: 'left'

                });
                    // Flickity instance
                    var flkty = $slider.data('flickity');

                    // previous
                    $slider.closest(".hero-posts").find('.flick-slider-nav.prev').on('click', function () {
                        $slider.flickity('previous');
                    });
                    // next
                    $slider.closest(".hero-posts").find('.flick-slider-nav.next').on('click', function () {
                        $slider.flickity('next');
                    });
                } else {
                    $(this).closest('section').find('.videos-list').addClass('flex');
                }

            });
   
        
    }());

    var logoSlider = (function () {
        $sliders = $('.logo-slider');
       
        if (!$sliders.length) { return };
        $sliders.each(function () {
            var $slider = $(this);
            var count = $slider.find('.logo-slider__slide').length;
            if(count > 5) {
                $(this).closest('section').find('.flick-nav-container').addClass('active');
                $slider.flickity({
                    contain: true,
                    pageDots: false,
                    freeScroll: true,
                    prevNextButtons: false,
                    wrapAround: true,
                    cellAlign: 'left',
                    imagesLoaded: true
                 

                });
                // Flickity instance
                var flkty = $slider.data('flickity');

                    // previous
                $slider.closest(".logo-main").find('.flick-slider-nav.prev').on('click', function () {
                    $slider.flickity('previous');
                });
                // next
                $slider.closest(".logo-main").find('.flick-slider-nav.next').on('click', function () {
                    $slider.flickity('next');
                });
            }
            else {
                $(this).closest('section').find('.logo-slider').addClass('flex');
            }



        });
        
    }());

    var testimonialLogo = (function () {
        $sliders = $('.testimonial-logo-slider');
       
        if (!$sliders.length) { return };
        $sliders.each(function () {
            var $slider = $(this);
            var count = $slider.find('.testimonial-item').length;

            if(count > 3){
            $(this).closest('section').find('.flick-nav-container').addClass('active');
                $slider.flickity({
                    contain: true,
                    pageDots: false,
                    freeScroll: true,
                    prevNextButtons: false,
                    wrapAround: true,
                    cellAlign: 'left',

                });
            // Flickity instance
                var flkty = $slider.data('flickity');

                   // previous
                $slider.closest(".testimonial-logos").find('.flick-slider-nav.prev').on('click', function () {
                    $slider.flickity('previous');
                });
                // next
                $slider.closest(".testimonial-logos").find('.flick-slider-nav.next').on('click', function () {
                    $slider.flickity('next');
                });

            }


        });
        
    }());    

        var testimonialRatings = (function () {
        $sliders = $('.testimonial-ratings-slider');
       
        if (!$sliders.length) { return };
        $sliders.each(function () {
            var $slider = $(this);
            var count = $slider.find('.testimonial-item').length;

            if(count > 3){
            $(this).closest('section').find('.testimonial-ratings__nav').addClass('active');
                $slider.flickity({
                    contain: true,
                    pageDots: false,
                    freeScroll: true,
                    prevNextButtons: false,
                    wrapAround: true,
                    cellAlign: 'left',

                });

            // Flickity instance
            var flkty = $slider.data('flickity');

            $('.testimonial-ratings__nav button').click(function () {
                if ($(this).hasClass('flick-nav-arrow--next')) {
                    $slider.flickity('next');
                } else {
                    $slider.flickity('previous');
                }
            });


            }


        });
        
    }()); 



        var heroSlider = (function () {
        $sliders = $('.hero-slider');
       
        if (!$sliders.length) { return };
        $sliders.each(function () {
            var $slider = $(this);
            var $slider_card = $(this).find('.hero-slider__item');

            if($slider_card.length > 1) {
            $slider.flickity({
                contain: true,
                pageDots: false,
                freeScroll: true,
                prevNextButtons: false,
                wrapAround: true,
                cellAlign: 'left',
                autoPlay: 7000

            });
                // Flickity instance
                var flkty = $slider.data('flickity');
            }


        });
        
    }());    


 /*   var heroVideoContent = (function () {
        $sliders = $('.hero-video-slider');
       
        if (!$sliders.length) { return };
        $sliders.each(function () {
            var $slider = $(this);
                $slider.flickity({
                    contain: true,
                    pageDots: false,
                    freeScroll: false,
                    prevNextButtons: false,
            
             
                    autoPlay: 5000,
                    fade: true,
                    draggable: false


                });
                // Flickity instance
                var flkty = $slider.data('flickity');
            


        });
        
    }());    */

    var LoadMore = (function () {
        var $loadmore = $('#loadmore');
        if (!$loadmore.length) { return; }

        var $loadmore_text = $loadmore.text();

         if ($(".post-card").length < 9) {
                $loadmore.remove();
            }

        $loadmore.click(function () {
            var $this = $(this);
            var $postlist = $this.siblings('.loadmore-container');

            var query = $this.attr('data-query');
            var page = parseInt($this.attr('data-page'));
            var max = parseInt($this.attr('data-max'));
            var sortby = $this.attr('data-sortby');
            var reset = $this.attr('data-reset');
            var category = $this.attr('data-category');

            var data = {
                action: 'load_more_posts',
                query: query,
                page: page,
                sortby: sortby,
                category: category,
                reset: reset
            };

            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'post',
                data: data,
                beforeSend: function () {
                    $loadmore.attr('disabled', true).text('Loading Posts');
                },
                error: function (res) {
                    res = JSON.parse(res);
                    console.log(res);
                },
                success: function (res) {
                    console.log(res);
                res = JSON.parse(res);
                    var current_page = res.page;
                    var posts = res.posts;

                    if (res.status !== 'error') {
                        $loadmore.attr('disabled', false).text($loadmore_text);
                        $this.attr('data-page', current_page);

                        if (res.reset) {
                            $('.post-card').remove();
                        }
                        $postlist.append(posts);

                        lazyLoadInstance = new LazyLoad();

                    } else {
                        $loadmore.remove();
                    }

                    if (current_page >= max) {
                        $loadmore.remove();
                    }

           
                }
            });
        });
    }());

    var Tabs = (function () {
        $('.tabgroup > div').hide();
        $('.tabgroup:first-of-type > div').show();
        $('.tabs .dropdown button').click(function (e) {
            //console.log("fire");
            e.preventDefault();
            var $this = $(this),
                tabgroup = '#' + $this.parents('.tabs').data('tab'),
                others = $this.closest('.tabs').find("button");
            target = $this.data('tab');
            $(this).closest('.tabs').find('.dropdown').removeClass('active');
            others.removeClass('active');
            $this.addClass('active');
            $('.tabgroup > div').hide();
            $(target).show();

        });

        $('.tabs .btn--reset').click(function () {
            $(this).closest('.tabs').find('.dropdown').toggleClass('active');
        });

    }());

     $('.read-btn').click(function () {
        $(this).closest('.content-block').find('.read-more').toggle();
      });

/*    var HeroPostSlider = (function () {
        $sliders = $('.hero--blog .slider');
        if (!$sliders.length) { return };
        $sliders.each(function () {
            var $slider = $(this);
            $slider.flickity({
                prevNextButtons: false,
                contain: true,
                watchCSS: true
            });
        });
    }());
*/
      var portfolio = (function () {
        $sliders = $('.portfolio-images');
        if (!$sliders.length) { return };
        $sliders.each(function () {
            var $slider = $(this);
            $slider.flickity({
                prevNextButtons: false,
                contain: true,
                pageDots: false,
                wrapAround: true,
                cellAlign: 'left'
            });

        $('.portfolio__nav button').click(function () {
                if ($(this).hasClass('flick-nav-arrow--next')) {
                    $slider.flickity('next');
                } else {
                    $slider.flickity('previous');
                }
            });

        });
    }());



    var BlogFilter = (function () {
        var $section = $('.blog-content');
        if (!$section.length) { return; }

        var $sortBy = $section.find('.post-filter select');
        $sortBy.change(function () {
            var selected = this.options[this.options.selectedIndex].value;

            var $loadmore = $('#loadmore');

            $loadmore.attr('data-reset', true);
            $loadmore.attr('data-sortby', selected);

            $loadmore.attr('data-page', 0).trigger('click');
            setTimeout(function () { $loadmore.attr('data-reset', null); }, 1000);
        });

    }());


   $('body').on('click', '.hubspot-trigger', function() {
        var id = $(this).attr('id');
        if (id !== undefined && id.includes('-button')) {
            $('#' + id.replace('-button', '-popup')).addClass('active');
        } else {
            $(this).closest('section').find(".hublightbox").addClass('active');
        }
  });

    $('body').on('click', '.country-trigger', function() {
        $(this).closest('section').find(".all-countries-popup--flexible").addClass('active');
  });

    $('body').on('click', 'a', function() {
        if ($(this).attr('href') == '#all-countries-popup') {
            $(".all-countries-popup--main").addClass('active');
        } 
  });

    $('body').on('click', '.hs-popup-trigger', function() {
        $(this).parent().find(".hublightbox").addClass('active');
  });


/*  $('body').on('click', '.hubspot-trigger-flexible', function() {
        $(this).closest("section").find(".hublightbox-flexible").addClass('active');
  });
*/
    $('body').on('click', '.datasheet-trigger', function() {
        var id = $(this).data('id');
    $(".datasheet"+ id).addClass('active');
  });


   $('body').on('click', '.hs-flex-trigger', function() {
        var id = $(this).data('id');
        $("#" + id).addClass('active');
   
  });


var Cookie = ( function () {
  /**
   * get cookie value
   * @param   {String} strName - cookie name
   * @returns {String}         - cookie value
   */
  var get = function ( strName ) {
    // seperate cookies into array
    var arrCookies = decodeURIComponent( document.cookie ).split( "; " );
    // initiate cookie value return
    var strCookieValue;
    // remove whitespace
    strName = strName.trim();

    // cycle through cookies
    arrCookies.forEach( function ( strCookie ) {
      // find cookie and return value
      if ( strCookie.indexOf( strName + "=" ) === 0 ) {
        strCookieValue = strCookie.split( '=' )[ 1 ];
      }
    } );

    // if cookie value is undefined
    if ( !strCookieValue ) console.warn( "Cookie '" + strName + "' does not exist" );
    // return cookie value
    return strCookieValue;

  };
  /**
   * Set cookies
   * @param {String} strName        - cookie name
   * @param {String} strValue       - cookie value
   * @param {Number} [intExpInDays] - days until cookie expires
   * @param {String} [strPath]      - path where cookie is accessible
   */
  var set = function ( strName, strValue, intExpInDays, strPath ) {
    var strExpires = "";
    /* if strPath is undefined
     * default to domain root */
    strPath = strPath || "/";

    // if intExpInDays is defined
    if ( intExpInDays ) {
      var objExpireDate = new Date();
      // set time to expiration date
      objExpireDate.setTime( objExpireDate.getTime() + ( intExpInDays * 24 * 60 * 60 * 1000 ) );
      // format to cookie param
      strExpires = "expires=" + objExpireDate.toUTCString() + ";";
    }
    // set cookie
    document.cookie = strName.trim() + "=" + strValue.trim() + ";" + strExpires + "path=" + strPath;
  };

  /**
   * remove cookie
   * @param {String} strName - cookie name
   */
  var remove = function ( strName ) {
    // if cookie exists - set expiration to day before
    if ( get( strName ) !== undefined ) set( strName, '_', -1 );
  };

  return {
    get: get,
    set: set,
    delete: remove,
  };
} )();


  var mailingList = (function(){
        current = window.location.pathname;
        if (!$("body").is(".home, .page-id-173, .page-id-15498")) {
                $(document).mouseleave(function () {
                        var newsLetterCookie = Cookie.get("mailingListPopup")
                        if (newsLetterCookie) {
                            //  console.log('cookie set');
                        } else {
                            Cookie.set('mailingListPopup', 'true', 7);
                            $('.pdm-lightbox.mailing-list').addClass('active');
                        }
                        
                });
            }
    }());


   var welcomePopup = (function(){
        current = window.location.pathname;
        if (current == '/') {  
            if(sessionStorage && !sessionStorage.getItem('isshow')){
                $('.pdm-lightbox.welcome-hp').addClass('active');
                sessionStorage.setItem('isshow', true);
            }
        }
    }());

    var multiFamilyPopup = (function(e){
     $(document).scroll(function() {
          var y = $(this).scrollTop();
          if (y > 800) {
            $('.multifamily-popup').addClass('active');
                 $(document).off('scroll');
          } 
        });

      $(document).on('click', '.close-thumb', function () {
        $('.multifamily-popup').removeClass('active');
      });
    }());


/* ========================================================================================================================

    Filter

======================================================================================================================== */

var mainFilters = (function(){
var filter = urlParams.get('resource_types');
if( filter ){
    $('.reset-button-container').removeClass('hide');
    $( ".category-list button" ).each(function() {
        var slug = $(this).attr("data-slug");
        var term = $(this).attr('data-term');
        var catName = $('.post-filter--content-type').find('.dropdown-btn__inner p');
        if(slug == filter+"/") {
            $(catName).html(term);
            $(this).addClass('active');
        } 
});
    $('.blog-content').find("#loadmore").addClass("hide");
    var url = window.location.href;
    var filters = [{
        slug: filter,
        taxonomy: "resource_types",
        type: "resources"
    }];
    //console.log(filters);
   $.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        dataType: 'html',
        data: {
          action: 'filter_posts',
          filter: JSON.stringify(filters),
        },
        success: function(res) {
          $('.blog-posts').html(res);
            lazyLoadInstance = new LazyLoad();
        }
      })
}

// Load more Ajax functionality disabled, to enable again visit code version 6/5/24


// $('.category-list button').on('click', function() {
//     var text = $(this).text();
//     var catName = $(this).closest('.post-filter').find('.dropdown-btn__inner p');
//     var categoryList = $(this).closest(".category-list");
//     var data = $(this).data();
//     var taxonomy = data.taxonomy;
//     var slug = data.slug;
//     var filters = []; 

//         var filter = urlParams.get('resource_types');
//         if( filter ){
//              var contentTypeText = $('.post-filter--content-type').find('.dropdown-btn__inner p');
//             var uri = window.location.toString();
//             if (uri.indexOf("?") > 0) {
//                 var clean_uri = uri.substring(0, uri.indexOf("?"));
//                 window.history.replaceState({}, document.title, clean_uri);
//                 $(contentTypeText).html("Select Category");
//             }

//         }


//     $('.blog-content').addClass('loading');
//     $('html, body').animate({
//         scrollTop: $('.blog-content').offset().top + $('header.gheader').height() - 64
//     }, 1000);
//    $(this).closest("section").find("#loadmore").addClass("hide");
//    $(categoryList).attr("data-value", JSON.stringify(data));
//    $( ".category-list" ).each(function() {
//         var value = $(this).attr("data-value");
//         if(value.length) {
//             filters.push(JSON.parse(value));
//         }
//     });
//     $(catName).html(text);
//     $('.reset-button-container').removeClass('hide');
//     $.ajax({
//         type: 'POST',
//         url: '/wp-admin/admin-ajax.php',
//         dataType: 'html',
//         data: {
//           action: 'filter_posts',
//           filter: JSON.stringify(filters),
//         },
//         success: function(res) {
//           $('.blog-posts').html(res);
//             lazyLoadInstance = new LazyLoad();
//              $('.blog-content').removeClass('loading');
//         }

//       })


//     // Banner img in the header
//     var bannerImg = $(this).attr('data-banner-img');
//     if(bannerImg) {
//         var content = $(this).find('.banner-img-content').html();
//         $('.blog-posts-banner').html(content);
//     } else {
//         $('.blog-posts-banner').empty();
//     }
//     });

  }());





var hsMultiStep = (function(){
        
        var $hsMultiForm = $('#country-step-form');
        
        if( !$hsMultiForm.length ){ return; }
        

 var generateFormOptions = function(form, index, data, options, $container) {
            
            var forms = $container.data('forms').split(',');
            var portalId = '3902512';
            var target = '#country-step-form';
            return {
                portalId: portalId,
                formId: form,
                target: target,

                onFormReady: function(form) {
                  
                    setTimeout(function(){
                        $(target).removeClass('loading');
                    },500);
                },
                onFormSubmit: function(form) {


                    $(target).addClass('loading');
                    if (data.length === 0) {
                        var incoming = $(form).serializeArray();
                        data.push(incoming[0]);
                        data.push(incoming[1]);
                    }

                 if(data[1].value == "Yes") {
                    window.location.href = 'https://www.parcelpending.com/faqs/';
                    $('#country-step-form').hide();
                 }

                },
                onFormSubmitted: function() {
                    //console.log(data);
                    var country = data[0].value;
                    var resident = data[1].value;

        

                       if (country == 'United Kingdom' || country == 'Ireland' ) {
                            $(target).empty();
                            hbspt.forms.create(options[1]);
                        }
                        else if (country == 'Canada' || country == 'United States' ) {
                            $(target).empty();
                            hbspt.forms.create(options[2]);
                        }
                        else{
                            $(target).removeClass('loading');
                        }
                    
                }
            };
        };

        var multiStepForm = function($container) {
            
            var forms = $container.data('forms').split(',');
            var target = '#country-step-form';
            
            var data = [];
            var options = [];
            
            forms.forEach(function (form, index) {
                options.push(generateFormOptions(form, index, data, options, $container));
            });
            
            hbspt.forms.create(options[0]);
        };
        
        $hsMultiForm.each(function(){

            multiStepForm($(this));
            
        });
        
    }());

    var displayThankYouAllForms = (function () {
        let $allHubspotForms = document.querySelectorAll('.hbspt-form');

        if (!$allHubspotForms.length) { return; }

        $( window ).on( "message", function( event ) {
            if (
                event.originalEvent.data.eventName &&
                event.originalEvent.data.eventName === 'onFormSubmitted'
                ) {
                $allHubspotForms.forEach((form) => {
                    let thankYouMessage = $allHubspotForms[0].innerHTML;

                    form.innerHTML = thankYouMessage;
                });
            }

        });
    }());

    var contentScrollCards = (function () {
        let $contentScrollCards = document.querySelectorAll('.content-scroll-cards');

        if (!$contentScrollCards.length) { return; }
        let scrollButton = document.querySelector('.content-scroll-cards__scroll-button');

        if (window.innerWidth < 768) {
            const loadMoreElement = '<p class="content-scroll-cards__scroll-button--text">See More</p>';

            scrollButton.insertAdjacentHTML('afterbegin', loadMoreElement);

            $contentScrollCards.forEach((scroll) => {
                let scrollCards = scroll.querySelectorAll('.content-scroll-cards__scroll-card');
                
                scrollCards.forEach((card, index) => {
                    if (index >= 4) {
                        card.classList.add('hidden');
                    }
                });
            });
    
            scrollButton.addEventListener('click', function() {
                let scrollCardsContainer = document.querySelector('.content-scroll-cards__scroll-cards');

                scrollCardsContainer.style.maxHeight = (scrollCardsContainer.scrollHeight + 100) + 'px';

                $contentScrollCards.forEach((scroll) => {
                    let hiddenCards = scroll.querySelectorAll('.content-scroll-cards__scroll-card.hidden');
                    hiddenCards.forEach(card => {
                        card.classList.remove('hidden');
                    });
    
                    if (hiddenCards.length === 0) {
                        scrollButton.classList.add('hidden');
                    }
                });
            });
        }
    }());
    
    /* ========================================================================================================================
    
        Eloqua Form
    
    ======================================================================================================================== */
    
    var eloquaFormPrefill = (function () {
        $(document).ready(function () {
            var $this = $(this);
            var contentTarget = $(`#${$this[0].className}`);

            var clidFormFields = ['utm_source', 'utm_medium', 'utm_term', 'utm_campaign', 'utm_content', 'gclid', 'FormPageURL', 'ga4_session_id', 'ga4_client_id', 'ga4_timestamp'];
    
            clidFormFields.forEach(element => {
                var queryParam = urlParams.get(element);

                if (element == 'FormPageURL') {
                    $('input[name="FormPageURL"]').each((index, field) => {
                        field.value = window.location;
                    });

                } else if ( $(`input[name="${element}"]`) && ( queryParam )) {

                    $(`input[name="${element}"]`).each((index, field) => {
                        field.value = queryParam;
                    });
                } 
            });
        });
      }());

    var eloquaMainFormSubmission = (function () {
        $(document).ready(function () {
            var $allForms = document.querySelectorAll("form");

            if (!$allForms.length) { return; }

            // Loop through all forms on the page
            document.querySelectorAll("form").forEach(function(form) {
                // Check if the form action includes "eloqua"
                if (!form.action.includes("eloqua")) return;
                
                // Form init with dynamic inputs
                let industryType1 = form.querySelector("select[name='industryType1']");
                const productInterestInput = form.querySelector("input[name='ProductInterest']");
                const verticalTypeInput = form.querySelector("input[name='VerticalType']");

                // Form front end validation
                form.querySelectorAll(".elq-required").forEach(function(element) {
                    // Find the input or select element in the form
                    let inputParent = element.closest(".form-element-layout");
                    let inputElement = inputParent.querySelector("input") ?? inputParent.querySelector("select") ?? inputParent.querySelector("textarea");
                    // Set the input or select element as required
                    inputElement.setAttribute("required", "true");
                });

                // Function to update product interest based on the value
                const updateProductInterest = (value) => {
                switch (value.toLowerCase()) {
                    // Update the product interest based on the value
                    case "commercial":
                    productInterestInput.value = "PLS - Corporate";
                    break;
                    case "host":
                    case "open locker network":
                    case "distributor":
                    productInterestInput.value = "PLS - Open Network";
                    break;
                    case "carrier":
                    productInterestInput.value = "PLS - PUDO (Carriers)";
                    break;
                    case "higher ed":
                    productInterestInput.value = "";
                    break;
                    case "retail":
                    productInterestInput.value = "PLS - Retail";
                    break;
                }
                }

                if(industryType1) {
                // Get the first option value
                let selectIndustryTypeOptions = industryType1.querySelectorAll("option");
                let firstOptionValue = selectIndustryTypeOptions[0].value;

                // Update the product interest based on the first option value
                updateProductInterest(firstOptionValue);

                // Set the vertical type input value based on the first option value
                if(firstOptionValue === "MultiFamily") {
                    verticalTypeInput.value = 'MultiFamily';
                } else {
                    verticalTypeInput.value = 'Non MultiFamily';
                }
                }

                // Dynamic inputs
                const dynamicInputs = {
                "higher-ed": {
                    inputs: ["SchoolSize", "LockersFor"]
                },
                "retail": {
                    inputs: ["locations", "Install"]
                },
                "multifamily": {
                    inputs: ["numberofunits"]
                }
                };

                // Loop through the dynamic inputs and hide the input elements
                Object.entries(dynamicInputs).forEach(([key, value]) => {
                value.inputs.forEach((input) => {
                    const inputElement = form.querySelector(`[name=${input}]`);
                    if (inputElement) {
                    inputElement.closest(".form-element-layout").classList.add("dynamic-input", "hidden");
                    inputElement.removeAttribute('required');
                    }
                });
                });

                // Form submit thank you message
                form.addEventListener("submit", function(event) {
                event.preventDefault();

                const getInputValue = (selector, defaultValue = "") => {
                    const element = form.querySelector(selector);
                    return element ? element.value : defaultValue;
                };

                const getCheckboxValue = (selector) => {
                    const element = form.querySelector(selector);
                    return element ? element.checked : false;
                };

                const formFields = {
                    email: getInputValue("input[name='emailAddress']"),
                    phone: getInputValue("input[name='Phone']"),
                    industry: getInputValue("select[name='industryType1']"),
                    company: getInputValue("input[name='company']"),
                    title: getInputValue("input[name='title']"),
                    zipCode: getInputValue("input[name='ZipCode']"),
                    country: getInputValue("select[name='country']"),
                    locations: getInputValue("input[name='locations']"),
                    howDidYouHear: getInputValue("textarea[name='HowDidYouHearAboutUs']"),
                    notes: getInputValue("textarea[name='Notes']"),
                    singleCheckbox: getCheckboxValue("input[name='singleCheckbox']"),
                    solution: getInputValue("input[name='solution']"),
                    productInterest: getInputValue("input[name='ProductInterest']"),
                    sfdc_campaign_status: getInputValue("input[name='sfdc_campaign_status']"),
                    sfdc_global_campaign_id: getInputValue("input[name='sfdc_global_campaign_id']"),
                    sfdc_pls_us_campaign_id: getInputValue("input[name='sfdc_pls_us_campaign_id']"),
                    sfdc_us_campaign_id: getInputValue("input[name='sfdc_us_campaign_id']"),
                    sfdc_monet_campaign_id: getInputValue("input[name='sfdc_monet_campaign_id']"),
                    sfdc_ap_ar_campaign_id: getInputValue("input[name='sfdc_ap_ar_campaign_id']"),
                    sfdc_cxm_campaign_id: getInputValue("input[name='sfdc_cxm_campaign_id']"),
                    verticalType: getInputValue("input[name='VerticalType']"),
                    assignmentLeadChannelUK: getInputValue("input[name='AssignmentLeadChannelUK']"),
                    utm_source: getInputValue("input[name='utm_source']"),
                    utm_medium: getInputValue("input[name='utm_medium']"),
                    utm_term: getInputValue("input[name='utm_term']"),
                    utm_campaign: getInputValue("input[name='utm_campaign']"),
                    utm_content: getInputValue("input[name='utm_content']"),
                    gclid: getInputValue("input[name='gclid']"),
                    formPageURL: getInputValue("input[name='FormPageURL']"),
                    mostRecentSearchEngine: getInputValue("input[name='MostRecentSearchEngine']"),
                    mostRecentReferrer: getInputValue("input[name='MostRecentReferrer']"),
                    totalVisits: getInputValue("input[name='Total_Visits']"),
                    ga4_session_id: getInputValue("input[name='ga4_session_id']"),
                    ga4_client_id: getInputValue("input[name='ga4_client_id']"),
                    ga4_timestamp: getInputValue("input[name='ga4_timestamp']"),
                    assetType: getInputValue("input[name='assetType']"),
                    videoProvider: getInputValue("input[name='videoProvider']")
                };

                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    event: "user_data",
                    user_data:{
                    email: formFields.email,
                    phone_number: formFields.phone,
                    industry_type: formFields.industry,
                    address: {
                        first_name: formFields.firstName,
                        last_name: formFields.lastName,
                        street: formFields.address,
                        country: formFields.country,
                        region: formFields.state,
                        city: formFields.city,
                        postal_code: formFields.zipCode
                    }
                    }
                });

                $.ajax({
                    type: 'POST',
                    url: '/wp-admin/admin-ajax.php',
                    dataType: 'json',
                    data: {
                        action: 'register_eloqua_submissions',
                        formFields: formFields
                    }
                });

                // Get the form type
                const formType = this.querySelector("input[name='formType']").value;
                let disableThankYou = false;

                // Check if the form type is not "contact"
                if (formType !== "contact") {
                    disableThankYou = true;
                };

                // If the thank you message is disabled, submit the form
                if (disableThankYou) {
                    this.submit();
                } else {
                    // Get the thank you message
                    const TYmessage = this.querySelector("input[name='TYmessage']").value;

                    // Get form data and submit bypassing form redirect
                    var xhr = new XMLHttpRequest();
                    var formData = new FormData(this);
                    xhr.open('POST', this.action, true);
                    xhr.onload = function() {
                    if (xhr.status === 200) {
                        form.innerHTML= TYmessage;
                    } else {
                        console.log("error");
                    }
                    };
                    xhr.send(formData);  // Send the form data via AJAX
                };
                });

                // Dynamic inputs
                form.addEventListener("change", function(event) {
                // Check if the changed element is the industry type input
                if (event.target.name === "industryType1") {
                    let inputsToInsert = [];
                    let dynamicInputElements = this.querySelectorAll(".dynamic-input");

                    // Hide all dynamic input elements and remove their required attribute
                    if (dynamicInputElements.length > 0) {
                    dynamicInputElements.forEach((input) => {
                        input.closest(".form-element-layout").classList.add("hidden");
                        let inputElement = input.querySelector('input')
                        let selectElement = input.querySelector('select');

                        if(inputElement) {
                        inputElement.removeAttribute('required');
                        } else if (selectElement) {
                        selectElement.removeAttribute('required');
                        }
                    });
                    }

                    // Update related input values based on the selected industry type
                    if(event.target.value === "MultiFamily") {
                    verticalTypeInput.value = "MultiFamily";
                    productInterestInput.value = "PLS - MultiFamily";
                    } else {
                    verticalTypeInput.value = "Non MultiFamily";
                    }

                    // Update the product interest based on the selected industry type
                    updateProductInterest(event.target.value);

                    // Determine which dynamic inputs to insert based on the selected industry type
                    switch (event.target.value) {
                    case "Higher Ed":
                        inputsToInsert = dynamicInputs["higher-ed"].inputs;
                        break;
                        case "Retail":
                        inputsToInsert = dynamicInputs["retail"].inputs;
                        break;
                    case "MultiFamily":
                        inputsToInsert = dynamicInputs["multifamily"].inputs;
                        break;
                    }

                    // Insert the determined dynamic inputs
                    if (inputsToInsert.length > 0) {
                    inputsToInsert.forEach((inputToInsert) => {
                        const inputElement = this.querySelector(`[name=${inputToInsert}]`);
                        if(!inputElement) return;

                        // If not already required, make the input required except for a specific case
                        if (inputElement.name !== 'LockersFor' && inputElement.required === false) {
                        inputElement.setAttribute("required", "true");
                        }

                        // Show the input element and mark it as required
                        inputElement.closest(".form-element-layout").classList.remove("hidden");

                        // If the label does not already contain a star, add one
                        if (!inputElement.closest(".form-element-layout").querySelector('label').innerHTML.includes('*')) {
                        inputElement.closest(".form-element-layout").querySelector('label').innerHTML += '<span style="color:red;">*</span>';
                        }
                    });
                    };
                }
                });
            });  
        });
      }());

});
